var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g = Object.create((typeof Iterator === "function" ? Iterator : Object).prototype);
    return g.next = verb(0), g["throw"] = verb(1), g["return"] = verb(2), typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (g && (g = 0, op[0] && (_ = 0)), _) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
var __spreadArray = (this && this.__spreadArray) || function (to, from, pack) {
    if (pack || arguments.length === 2) for (var i = 0, l = from.length, ar; i < l; i++) {
        if (ar || !(i in from)) {
            if (!ar) ar = Array.prototype.slice.call(from, 0, i);
            ar[i] = from[i];
        }
    }
    return to.concat(ar || Array.prototype.slice.call(from));
};
var _a;
import { createAction, handleActions } from 'redux-actions';
import { createSelector } from 'reselect';
import { isEmpty } from 'lodash';
import Immutable from 'seamless-immutable';
import { AppConstant, SORT_DIRECTION, FULFILLED_STATUS, FeatureFlagNames } from 'constants/app.constant';
import { SystemType } from 'models';
import { isFeatureEnabled } from 'services/feature-flag.service';
import { mergeAndSumByCourseId } from 'reports/ps/helpers';
import { fetchAllCourseAggregations } from 'reports/ps/services/ps.service';
import { fetchExternalUserInfo, fetchCrosswalkUser } from 'services/user-management.service';
import { getSortedCourseByAverageScore } from 'reports/ps/components/pages/student-profile/sherpath-assignments-tab/SherpathAssignmentTabHelper';
var getPSState = function (state) { return state[AppConstant.reduxResources.PS_STATE]; };
export var initialState = Immutable({
    isSherpathCourseListLoading: true,
    hadDemoEvolveUsername: null,
    selectedProgramId: null,
    selectedExamId: null,
    selectedStudentDetail: {},
    selectedStudentId: null,
    selectedSHStudentId: 3,
    sherpathCourseList: [],
    ngnItems: [],
    sherpathAssignmentsCardAndTabSortInteraction: null,
    sHAssignmentsCardAndTabSortInteraction: null
});
var prefixActionName = 'PS';
var setSelectedStudentId = createAction("".concat(prefixActionName, "/SET_SELECTED_STUDENT_ID"));
var setHadDemoEvolveUsername = createAction("".concat(prefixActionName, "/SET_HAD_DEMO_EVOLVE_USERNAME"));
var setSelectedSHStudentId = createAction("".concat(prefixActionName, "/SET_SELECTED_SH_STUDENT_ID"));
var setSherpathCourseList = createAction("".concat(prefixActionName, "/SET_SHERPATH_COURSE_LIST"));
var setIsSherpathCourseListLoading = createAction("".concat(prefixActionName, "/SET_IS_SHERPATH_COURSE_LIST_LOADING"));
var restoreState = createAction("".concat(prefixActionName, "/RESTORE"));
var setSelectedStudentDetail = createAction("".concat(prefixActionName, "/SET_SELECTED_STUDENT_DETAIL"));
var setSelectedExamMixedId = createAction("".concat(prefixActionName, "/SET_SELECTED_EXAM_MIXED_ID"));
var setSelectedProgramId = createAction("".concat(prefixActionName, "/SET_SELECTED_PROGRAM_ID"));
var setSherpathAssignmentsCardAndTabSortInteraction = createAction("".concat(prefixActionName, "/SET_SHERPATH_ASSIGNMENTS_CARD_AND_TAB_SORT_INTERACTION"));
var setSHAssignmentsCardAndTabSortInteraction = createAction("".concat(prefixActionName, "/SET_SH_ASSIGNMENTS_CARD_AND_TAB_SORT_INTERACTION"));
var setUserIdFromEvolveUsername = function (evolveUsername) { return function (dispatch) { return __awaiter(void 0, void 0, void 0, function () {
    return __generator(this, function (_a) {
        switch (_a.label) {
            case 0: return [4 /*yield*/, fetchExternalUserInfo(evolveUsername)
                    .then(function (res) {
                    if (!isEmpty(res.data)) {
                        dispatch(setSelectedStudentId(res.data.id));
                    }
                    else {
                        dispatch(setSelectedStudentId(null));
                    }
                })
                    .catch(function () {
                    dispatch(setSelectedStudentId(null));
                })];
            case 1:
                _a.sent();
                return [2 /*return*/];
        }
    });
}); }; };
export var getSherpathCourseListData = function (selectedStudentId) { return function (dispatch, getState) { return __awaiter(void 0, void 0, void 0, function () {
    var appState, isSherpathClassicLinkEnabled, eolsUserIdsByUserNameAndType, courseList_1, fetchPromise, fetchResult, defaultSortedCourseList, error_1;
    return __generator(this, function (_a) {
        switch (_a.label) {
            case 0:
                dispatch(setIsSherpathCourseListLoading(true));
                _a.label = 1;
            case 1:
                _a.trys.push([1, 6, 7, 8]);
                appState = getState()[AppConstant.reduxResources.APP_STATE];
                isSherpathClassicLinkEnabled = isFeatureEnabled(appState.featureFlags, FeatureFlagNames.SHERPATH_CLASSIC_LINK_ENABLED);
                if (!selectedStudentId) return [3 /*break*/, 4];
                return [4 /*yield*/, fetchCrosswalkUser(selectedStudentId.toString(), SystemType.EVOLVETYPE)];
            case 2:
                eolsUserIdsByUserNameAndType = (_a.sent()).data.eolsUserIdsByUserNameAndType;
                courseList_1 = [];
                fetchPromise = eolsUserIdsByUserNameAndType.map(function (eolsUserId) {
                    return fetchAllCourseAggregations(eolsUserId);
                });
                return [4 /*yield*/, Promise.allSettled(fetchPromise)];
            case 3:
                fetchResult = _a.sent();
                fetchResult.forEach(function (res) {
                    if (res.status === FULFILLED_STATUS) {
                        courseList_1 = __spreadArray(__spreadArray([], courseList_1, true), res.value.data.content, true);
                    }
                });
                courseList_1 = mergeAndSumByCourseId(isSherpathClassicLinkEnabled ? courseList_1 : courseList_1.filter(function (course) { return !course.isSherpathClassicCourse; }));
                defaultSortedCourseList = courseList_1.slice(0).sort(function (a, b) { return getSortedCourseByAverageScore(a, b, SORT_DIRECTION.ASC); });
                dispatch(setSherpathCourseList(defaultSortedCourseList));
                return [3 /*break*/, 5];
            case 4:
                dispatch(setSherpathCourseList([]));
                _a.label = 5;
            case 5: return [3 /*break*/, 8];
            case 6:
                error_1 = _a.sent();
                dispatch(setSherpathCourseList([]));
                return [3 /*break*/, 8];
            case 7:
                dispatch(setIsSherpathCourseListLoading(false));
                return [7 /*endfinally*/];
            case 8: return [2 /*return*/];
        }
    });
}); }; };
var actions = {
    setSelectedStudentId: setSelectedStudentId,
    setSelectedSHStudentId: setSelectedSHStudentId,
    setSherpathCourseList: setSherpathCourseList,
    setIsSherpathCourseListLoading: setIsSherpathCourseListLoading,
    restoreState: restoreState,
    setUserIdFromEvolveUsername: setUserIdFromEvolveUsername,
    setSelectedStudentDetail: setSelectedStudentDetail,
    setSelectedExamMixedId: setSelectedExamMixedId,
    setSelectedProgramId: setSelectedProgramId,
    setSherpathAssignmentsCardAndTabSortInteraction: setSherpathAssignmentsCardAndTabSortInteraction,
    setSHAssignmentsCardAndTabSortInteraction: setSHAssignmentsCardAndTabSortInteraction,
    setHadDemoEvolveUsername: setHadDemoEvolveUsername
};
var reducer = handleActions((_a = {},
    _a[actions.setSherpathCourseList] = function (state, _a) {
        var payload = _a.payload;
        return Immutable.set(state, 'sherpathCourseList', payload);
    },
    _a[actions.setSelectedStudentId] = function (state, _a) {
        var payload = _a.payload;
        return Immutable.set(state, 'selectedStudentId', payload);
    },
    _a[actions.setSelectedSHStudentId] = function (state, _a) {
        var payload = _a.payload;
        return Immutable.set(state, 'selectedSHStudentId', payload);
    },
    _a[actions.setIsSherpathCourseListLoading] = function (state, _a) {
        var payload = _a.payload;
        return Immutable.set(state, 'isSherpathCourseListLoading', payload);
    },
    _a[actions.restoreState] = function (state, _a) {
        var payload = _a.payload;
        return state.merge(payload);
    },
    _a[actions.setSelectedStudentDetail] = function (state, _a) {
        var payload = _a.payload;
        return Immutable.set(state, 'selectedStudentDetail', payload);
    },
    _a[actions.setSelectedExamMixedId] = function (state, _a) {
        var payload = _a.payload;
        return Immutable.set(state, 'selectedExamId', payload);
    },
    _a[actions.setSelectedProgramId] = function (state, _a) {
        var payload = _a.payload;
        return Immutable.set(state, 'selectedProgramId', payload);
    },
    _a[actions.setSherpathAssignmentsCardAndTabSortInteraction] = function (state, _a) {
        var payload = _a.payload;
        return Immutable.set(state, 'sherpathAssignmentsCardAndTabSortInteraction', payload);
    },
    _a[actions.setSHAssignmentsCardAndTabSortInteraction] = function (state, _a) {
        var payload = _a.payload;
        return Immutable.set(state, 'sHAssignmentsCardAndTabSortInteraction', payload);
    },
    _a[actions.setHadDemoEvolveUsername] = function (state, _a) {
        var payload = _a.payload;
        return Immutable.set(state, 'hadDemoEvolveUsername', payload);
    },
    _a), initialState);
var selectors = {
    getSelectedStudentId: createSelector(getPSState, function (state) { return state.selectedStudentId; }),
    getDemoHadEvolveUsername: createSelector(getPSState, function (state) { return state.hadDemoEvolveUsername; }),
    getSelectedSHStudentId: createSelector(getPSState, function (state) { return state.selectedSHStudentId; }),
    getSherpathCourseList: createSelector(getPSState, function (state) { return state.sherpathCourseList; }),
    getIsSherpathCourseListLoading: createSelector(getPSState, function (state) { return state.isSherpathCourseListLoading; }),
    getSelectedStudentDetail: createSelector(getPSState, function (state) { return state.selectedStudentDetail; }),
    getSelectedExamId: createSelector(getPSState, function (state) { return state.selectedExamId; }),
    getSelectedProgramId: createSelector(getPSState, function (state) { return state.selectedProgramId; }),
    getNGNItems: createSelector(getPSState, function (state) { return state.ngnItems; }),
    getSherpathAssignmentsCardAndTabSortInteraction: createSelector(getPSState, function (state) { return state.sherpathAssignmentsCardAndTabSortInteraction; }),
    getSHAssignmentsCardAndTabSortInteraction: createSelector(getPSState, function (state) { return state.sHAssignmentsCardAndTabSortInteraction; })
};
export { actions as psActions, reducer as psReducer, selectors as psSelectors };
export { initialState as psInitialState };
